// components/FotoProducto.js — tanda fotos-resumen (7-oct-2026). La foto de «productos más
// vendidos» del Resumen con UN reintento. Por qué: la URL que pinta esa lista es el SNAPSHOT
// del pedido (raw.line_items[].image, groupOrdersByProduct.js) y apunta DIRECTO al origen de
// WordPress — sin el CDN i0.wp.com (Photon) que las fichas vivas sí usan. Un hipo del hosting
// la deja rota aunque el archivo exista (medido el 7-oct-2026: 502 del origen a las 14:56 COT
// y las 4 URLs «rotas» en 200 al rato — censo backend/scripts/censo-imagenes-resumen-20261007.js).
// Al fallar la carga se reintenta UNA sola vez vía i0.wp.com/<host><path> (Photon suele tener
// copia aunque el origen tosa); si también falla, el placeholder existente (.sr-prod-img--empty),
// nunca el ícono roto del navegador. SIN bucles de reintento: dos fallos = agotado.
import React, { useState, useEffect } from 'react';

// URL original → su espejo en Photon (https://i0.wp.com/<host><path>), o null si no se puede
// derivar (sin host legible) o si YA es de *.wp.com — reintentar contra sí misma sería el bucle
// que este componente promete no tener. La query NO viaja al respaldo (el snapshot no trae; una
// ?fit=… de Photon sobre Photon sería doble proxy).
export function urlRespaldoFoto(src) {
  const m = String(src || '').match(/^https?:\/\/([^/?#]+)(\/[^?#]*)?/i);
  if (!m) return null;
  const host = m[1].toLowerCase();
  if (host === 'i0.wp.com' || host.endsWith('.wp.com')) return null;
  return `https://i0.wp.com/${host}${m[2] || ''}`;
}

export default function FotoProducto({ src }) {
  const [actual, setActual] = useState(src || null);
  useEffect(() => { setActual(src || null); }, [src]); // período nuevo → foto nueva, reintento fresco
  if (!actual) return <div className="sr-prod-img sr-prod-img--empty" />;
  return (
    <img
      src={actual}
      className="sr-prod-img"
      alt=""
      onError={() => {
        const respaldo = urlRespaldoFoto(src);
        // Primer fallo: pasar al respaldo. Segundo (ya estamos en el respaldo) o sin
        // respaldo derivable: placeholder. Nunca un tercer intento.
        setActual(respaldo && actual !== respaldo ? respaldo : null);
      }}
    />
  );
}
